import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const pedidosService = {
  findByFiltro,
  findAll,
  nextNumber,
  doSave,
  doGet,
  findEstoque,
  validaEdicao,
  validaConclusao,
  findEstoquePorCodigoProduto,
  criar,
  verificarEstoqueLote,
  pendentesWms,
  consultarReservasProduto,
};

function verificarEstoqueLote(payload) {
  return defaultService.doPost(
    `${urlsConstants.API_PEDIDOS}verificarEstoqueLote`,
    payload,
  );
}

function validaConclusao(id) {
  return defaultService.doGet(`${urlsConstants.API_PEDIDOS}concluido/${id}`);
}

function validaEdicao(id) {
  return defaultService.doGet(`${urlsConstants.API_PEDIDOS}viewMode/${id}`);
}

function findEstoque(produto) {
  return defaultService.doGet(
    `${urlsConstants.API_PEDIDOS}getEstoque/${produto.codigoOmni}`,
  );
}

function findEstoquePorCodigoProduto(codigoProduto) {
  return defaultService.doGet(
    `${urlsConstants.API_PEDIDOS}getEstoquePorCodigoProduto/${codigoProduto}`,
  );
}

function findAll() {
  return defaultService.doGet(`${urlsConstants.API_PEDIDOS}findAll`);
}
function nextNumber() {
  return defaultService.doGet(`${urlsConstants.API_PEDIDOS}next`);
}
function findByFiltro(options: Options, filter: any): Promise<any> {
  const payload = {
    ...filter,
    page: options.page - 1,
  };

  return defaultService.doPost(`${urlsConstants.API_PEDIDOS}filtro`, payload);
}

function doSave(pedido) {
  if (!pedido.id) {
    return defaultService.doSave(urlsConstants.PEDIDOS, pedido);
  } else {
    return defaultService.doSave(`${urlsConstants.PEDIDOS}/`, pedido);
  }
}
function doGet(id) {
  return defaultService.doGet(`${urlsConstants.PEDIDOS}/${id}`);
}

function criar(pedido) {
  return defaultService.doPost(`${urlsConstants.API_PEDIDOS}criar`, pedido);
}

function pendentesWms() {
  return defaultService.doGet(`${urlsConstants.API_PEDIDOS}pendentesWms`);
}

function consultarReservasProduto(produto) {
  const params = [];

  params.push(
    `codigoProduto=${encodeURIComponent(
      String((produto && produto.codigoProduto) || ''),
    )}`,
  );

  if (produto && produto.codigoOmni) {
    params.push(
      `codigoOmie=${encodeURIComponent(String(produto.codigoOmni))}`,
    );
  }

  return defaultService.doGet(
    `${urlsConstants.API_PEDIDOS}reservasProduto?${params.join('&')}`,
  );
}
